export default __webpack_public_path__ + "static/media/bell.e489bc37.svg";